"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var Observable_1 = require("rxjs/Observable");
var MatPaginatorIntlImpl = /** @class */ (function (_super) {
    __extends(MatPaginatorIntlImpl, _super);
    function MatPaginatorIntlImpl(messageService) {
        var _this = _super.call(this) || this;
        _this.messageService = messageService;
        _this.getRangeLabel = function (page, pageSize, length) {
            var label;
            if (length === 0 || pageSize === 0) {
                if (_this.rangeLabel) {
                    label = _this.rangeLabel
                        .replace('{1}', '0')
                        .replace('{2}', "" + length);
                }
                else {
                    label = "0 of " + length;
                }
                return label;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            if (_this.rangeLabel) {
                label = _this.rangeLabel
                    .replace('{1}', startIndex + 1 + " - " + endIndex)
                    .replace('{2}', "" + length);
            }
            else {
                label = startIndex + 1 + " - " + endIndex + " of " + length;
            }
            return label;
        };
        _this.getMessages();
        return _this;
    }
    MatPaginatorIntlImpl.prototype.getMessages = function () {
        var _this = this;
        var messageSubscription = Observable_1.Observable.zip(this.messageService.getMessage('common.items-per-page.label'), this.messageService.getMessage('common.next-page.label'), this.messageService.getMessage('common.previous-page.label'), this.messageService.getMessage('common.first-page.label'), this.messageService.getMessage('common.last-page.label'), this.messageService.getMessage('common.range.label'))
            .subscribe(function (values) {
            _this.itemsPerPageLabel = values[0];
            _this.nextPageLabel = values[1];
            _this.previousPageLabel = values[2];
            _this.firstPageLabel = values[3];
            _this.lastPageLabel = values[4];
            _this.rangeLabel = values[5];
            _this.changes.next();
        });
    };
    MatPaginatorIntlImpl = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.MessageService])
    ], MatPaginatorIntlImpl);
    return MatPaginatorIntlImpl;
}(material_1.MatPaginatorIntl));
exports.MatPaginatorIntlImpl = MatPaginatorIntlImpl;
//# sourceMappingURL=mat-paginator-intl-impl.js.map